import { useState, useEffect } from 'react'
import { get } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import FormLoader from '../../../../components/loader/FormLoader'
import Pagination from '../../../../components/pagination/Pagination'
import { useNavigate } from 'react-router-dom'
import FullLoader from '../../../../components/loader/FullLoader'
import ResolveBooking from './ResolveBooking'
import TagChips from '../../../../components/tags/TagChips'
import TagFilterSelect from '../../../../components/tags/TagFilterSelect'
import TagEditModal from '../../../../components/tags/TagEditModal'
import '../../../../components/tags/tags.scss'

function CancelledBookings() {
  // const baseURL = (import.meta as any).env.VITE_BASE_URL
  const { notify, profile, tagsById } = useGlobalContext()
  const [transactions, setTransactions] = useState<any>({ transactions: [] })
  const [transactionsLoading, setTransactionsLoading] = useState(true)
  // const [paginationPage, setPaginationPage] = useState('default')
  const [chargeLoading, setChargeLoading] = useState(false)
  const [cancelledId, setCancelledId] = useState('')
  const [tab, setTab] = useState('pending')

  const navigate = useNavigate()
  const [selectedTags, setSelectedTags] = useState<string[]>([])
  const [tagEditing, setTagEditing] = useState<any | null>(null)

  function fetchOverDrafts(
    page: number,
    pageSize: number,
    selectedTab?: string,
    tagIds?: string[]
  ) {
    setTransactionsLoading(true)
    const status = selectedTab || tab
    const tagParams = (tagIds ?? selectedTags)
      .map((tagId) => `&tags=${tagId}`)
      .join('')
    get(
      `admin/cancelled-bookings?status=${status}&page=${page}&limit=${pageSize}${tagParams}`
    )
      .then((result: any) => {
        if (result.status === 200) {
          setTransactions(result.data)
        } else {
          notify('error', result.message)
        }
        setTransactionsLoading(false)
      })
      .catch(() => {
        setTransactionsLoading(false)
      })
  }
  function chargeOrder(id: string) {
    setChargeLoading(true)
    get(`admin/charge-cancelled-booking/${id}`)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'Charge Order Successful')
        } else {
          notify('error', result.message)
        }
        setChargeLoading(false)
      })
      .catch(() => {
        setChargeLoading(false)
      })
  }

  // const fetchFilteredOverDrafts = async (page: number) => {
  //   setTransactionsLoading(true)
  //   get(
  //     `admin/over-bookings?from=${dates.from}&to=${dates.to}&page=${page}&limit=10`
  //   )
  //     .then((result: any) => {
  //       if (result.status === 200) {
  //         setTransactions(result.data)
  //       } else {
  //         notify('error', result.message)
  //       }
  //       setTransactionsLoading(false)
  //     })
  //     .catch(() => {
  //       setTransactionsLoading(false)
  //     })
  // }

  useEffect(() => {
    fetchOverDrafts(1, 10)
  }, [])

  //Filter
  // const [dates, setDates] = useState({
  //   from: '',
  //   to: '',
  // })
  // const handleChange = (e: any) => {
  //   const { name, value } = e.target
  //   setDates((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }))
  // }
  // function handleFilter() {
  //   if (!dates.from || !dates.to) {
  //     notify('error', `Dates can't be empty`)
  //   } else {
  //     setPaginationPage('date')
  //     fetchFilteredOverDrafts(1)
  //   }
  // }

  //<----------- Download Excel and CSV --------------->
  // const [downloading, setDownloading] = useState(false)

  // const handleDownload = async (format: string) => {
  //   const token = sessionStorage.getItem('token')
  //   let apiUrl = `${baseURL}/admin/over-drafts/export?from=${dates.from}&to=${dates.to}&format=${format}`
  //   try {
  //     // Make an API request to fetch the Excel file
  //     setDownloading(true)
  //     const response = await fetch(apiUrl, {
  //       method: 'GET',
  //       headers: {
  //         // Add any necessary headers, like authorization if required
  //         Authorization: `Bearer ${token}`,
  //       },
  //     })

  //     if (!response.ok) {
  //       setDownloading(false)
  //       throw new Error('Failed to download file')
  //     }

  //     // Convert the response to a Blob
  //     const blob = await response.blob()

  //     // Extract the filename from the "Content-Disposition" header
  //     const fileName = `OverDraft-${dates.from} to ${dates.to}`

  //     // Create a download link for the Blob
  //     const url = window.URL.createObjectURL(blob)
  //     const a = document.createElement('a')
  //     a.href = url
  //     a.download = fileName // Use the filename from the backend
  //     document.body.appendChild(a) // Append to the DOM
  //     a.click() // Trigger the download
  //     a.remove() // Clean up
  //     window.URL.revokeObjectURL(url) // Release memory
  //     setDownloading(false)
  //   } catch (error) {
  //     console.error('Error downloading the file:', error)
  //   }
  // }

  function handleTabChange(selectedTab: 'pending' | 'resolved') {
    setTab(selectedTab)
    fetchOverDrafts(1, 10, selectedTab)
  }
  return (
    <div className='home'>
      {/* {downloading && <FullLoader />} */}
      {chargeLoading && <FullLoader />}
      {tagEditing && (
        <TagEditModal
          kind='cancelled'
          shipmentId={tagEditing._id}
          value={(tagEditing.tags || []).map((tag: any) =>
            typeof tag === 'string' ? tag : tag._id,
          )}
          onChange={(tagIds) => setTagEditing({ ...tagEditing, tags: tagIds })}
          onClose={() => {
            setTagEditing(null)
            fetchOverDrafts(1, 10, tab, selectedTags)
          }}
          title={`Tags — ${tagEditing.creatorName || 'cancelled booking'}`}
        />
      )}
      {cancelledId.length > 0 && (
        <ResolveBooking
          setCancelledId={setCancelledId}
          cancelledId={cancelledId}
          fetchOverDrafts={fetchOverDrafts}
        />
      )}
      {/* <div className='home_tag flex justify-between items-center'>
        <h1></h1>
        <div className='flex items-center select-wrapper'>
          <div className='flex items-center'>
            <p></p>
            <input
              type='date'
              name='from'
              value={dates.from}
              onChange={handleChange}
              max={new Date().toISOString().split('T')[0]}
            />
          </div>
          <div className='flex items-center'>
            <p>to</p>
            <input
              type='date'
              name='to'
              value={dates.to}
              onChange={handleChange}
              min={dates.from}
              max={new Date().toISOString().split('T')[0]}
            />
          </div>

          <button disabled={!dates.from || !dates.to} onClick={handleFilter}>
            filter
          </button>
        </div>
      </div> */}
      <div className='home_tables'>
        <div className='left'>
          {transactionsLoading ? (
            <FormLoader position='center' />
          ) : (
            <>
              <div className='flex justify-between items-center search-btns flex-wrap'>
                <div className='buttons flex'>
                  <button
                    onClick={() => handleTabChange('pending')}
                    className={tab === 'pending' ? 'activeM' : ''}
                  >
                    Pending
                  </button>
                  <button
                    onClick={() => handleTabChange('resolved')}
                    className={tab === 'resolved' ? 'activeM' : ''}
                  >
                    Resolved
                  </button>
                </div>
                <div className='tag-filter-wrap'>
                  <TagFilterSelect
                    value={selectedTags}
                    onChange={(tagIds) => {
                      setSelectedTags(tagIds)
                      fetchOverDrafts(1, 10, tab, tagIds)
                    }}
                  />
                </div>
              </div>
              {transactions.cancelledBookings?.length > 0 ? (
                <>
                  <div className='mobile-table'>
                    {transactions.cancelledBookings?.map(
                      (item: any, i: number) => (
                        <div
                          className='card'
                          key={item.bookingId}
                          onClick={() => {
                            navigate(`/admin/booking/${item.bookingId}`)
                          }}
                        >
                          <div className='flex justify-between row'>
                            <div className='count flex items-center justify-center'>
                              {i + 1}
                            </div>
                            <p> {new Date(item.createdAt).toLocaleString()}</p>
                          </div>
                          <div className='row flex justify-between'>
                            <h4>Creator</h4>
                            <p>{item.creatorName}</p>
                          </div>
                          <div className='row flex justify-between'>
                            <h4>Payment Method</h4>
                            <p>{item.paymentMethod}</p>
                          </div>
                          {item.tags?.length > 0 && (
                            <div className='row flex justify-between'>
                              <h4>Tags</h4>
                              <TagChips
                                tagIds={item.tags}
                                tagsById={tagsById}
                              />
                            </div>
                          )}
                          <div className='row flex justify-between'>
                            <h4>Charge</h4>
                            <p>NGN{item.charge.toLocaleString()}</p>
                          </div>
                          <div className='row flex justify-between'>
                            <h4>Channel</h4>
                            <p>{item.channel}</p>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                  <table className='desktop-table'>
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Date/Time</th>
                        <th>Creator</th>
                        <th>Payment Method</th>
                        <th>Charge</th>
                        <th>Channel</th>
                        <th>Tags</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.cancelledBookings?.map(
                        (item: any, i: number) => (
                          <tr key={item.bookingId}>
                            <td>{i + 1}</td>
                            <td>{new Date(item.createdAt).toLocaleString()}</td>
                            <td>{item.creatorName}</td>
                            <td>{item.paymentMethod}</td>
                            <td>NGN{item.charge.toLocaleString()}</td>
                            <td>{item.channel}</td>
                            <td
                              className='PU'
                              title='Edit tags'
                              onClick={() => setTagEditing(item)}
                            >
                              <TagChips
                                tagIds={item.tags}
                                tagsById={tagsById}
                                empty='+ tag'
                              />
                            </td>
                            <td>
                              <span
                                className='chip OND'
                                onClick={() => {
                                  navigate(`/admin/booking/${item.bookingId}`)
                                }}
                              >
                                view booking
                              </span>
                              {!item.charged ? (
                                <>
                                  {item.resolved ? (
                                    <span className='chip OK dif'>
                                      Resolved
                                    </span>
                                  ) : (
                                    (profile.role === 'super admin' ||
                                      profile.role === 'manager' ||
                                      profile.role === 'customer service') && (
                                      <>
                                        <span
                                          className='chip FD dif'
                                          onClick={() =>
                                            setCancelledId(item._id)
                                          }
                                        >
                                          Resolve
                                        </span>
                                        <span
                                          className='chip CCD dif'
                                          onClick={() => chargeOrder(item._id)}
                                        >
                                          Charge
                                        </span>
                                      </>
                                    )
                                  )}
                                </>
                              ) : (
                                <span className='chip OK dif'>Charged</span>
                              )}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={transactions.pagination.page}
                    totalCount={transactions.pagination.totalPages}
                    pageSize={transactions.pagination.limit}
                    onPageChange={(page: number, pageSize: number) => {
                      fetchOverDrafts(page, pageSize)
                      // paginationPage === 'default'
                      //   ? fetchOverDrafts(page)
                      //   : fetchFilteredOverDrafts(page)
                    }}
                  />
                </>
              ) : (
                <div className='empty flex justify-center'>
                  <div className='empty-cover'>
                    <Icon icon='la:clipboard-list' />
                    <h1 className='capitalize'>No {tab} Booking To Show</h1>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default CancelledBookings
